import clsx from 'clsx'
import React, { useContext } from 'react'

import { Link } from '@Components/Link'
import { ClubSignUpBanner } from '@Domains/Club/Components/ClubSignupBanner'
import styles from '@Domains/Navigation/Features/Menu/Menu.module.scss'
import { MetadataContext } from '@Globals/Metadata'
import { useTranslation } from '@Globals/Translations'
import { useCustomerSupportData } from '@Globals/useCustomerSupportData'

export const MenuFooter = ({ onContactClick }) => {
  const { t } = useTranslation()
  const { customerSupportDataMap } = useCustomerSupportData({ sourceID: 'mobile_menu_bottom_links' })
  const { cmsData, storeURL } = useContext(MetadataContext)

  return (
    <div className={styles.footer}>
      <ClubSignUpBanner className={clsx(styles.inMobileMenuFooter)}>
        <p>{t('common:join_club_newsletter')}</p>
      </ClubSignUpBanner>
      <Link className={styles.link} href={storeURL('articles')}>{t('header:ARTICLES_LABEL')}</Link>
      <Link className={styles.link} href={storeURL('collections')}>{t('header:COLLECTIONS_LABEL')}</Link>
      {cmsData.urls.giftGuide
        && <Link className={styles.link} href={storeURL(cmsData.urls.giftGuide.url || '')}>{cmsData.urls.giftGuide.title}</Link>}
      {customerSupportDataMap.returnsLogin
        && <Link className={styles.link} href={storeURL(customerSupportDataMap.returnsLogin.href)}>{customerSupportDataMap.returnsLogin.title}</Link>}
      <button className={styles.action} onClick={onContactClick} type="button">
        {t('footer:FOOTER_CONTACT_TITLE')}
      </button>
      {customerSupportDataMap.faq
        && <Link className={styles.link} href={storeURL(customerSupportDataMap.faq?.href)}>{customerSupportDataMap.faq?.title}</Link>}
    </div>
  )
}
